import styled from 'styled-components'

export const HeaderContainer = styled.header`
    display: flex;
    align-items: center;

    padding: 32px 0;
`

export const SearchBarSortAndFilter = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;

    width: 100%;

    .reports-approval-search {
        border-radius: 3px;

        align-items: center;

        .fa-search {
            font-size: large;
        }
    }
`

export const Sort = styled.div`
    width: 32px;
    height: 32px;

    border: 1px solid var(--gray-400);
    border-radius: 3px;
`
